import { Link } from "@nextui-org/link";

import Navbar from "@/components/navbar";

export default function DefaultLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <div className="relative flex flex-col h-screen">
      <Navbar />
      <main className="container mx-auto max-w-full flex-grow pt-16">
        {children}
      </main>
      <footer className="w-full flex items-center justify-center py-3">
        <Link
          isExternal
          className="flex items-center gap-1 text-current"
          href="naqeer.com"
          title="Naqeer"
        >
          <span className="text-default-600">Powered by</span>
          <p className="text-primary">Naqeer</p>
        </Link>
      </footer>
    </div>
  );
}
